<template>
  <div id="about">

    <el-row>
      <el-col :span="24">
        <div class="about-top">
      </div></el-col>
    </el-row>

    <el-row style="background: white;padding-top: 80px">
      <el-col :span="5">
        <el-menu
          default-active="1"
          class="el-menu-vertical-demo"
          background-color="#F8F8F8"
          text-color="#000000"
          active-text-color="#f2613f">
          <el-menu-item :class="index == 1 ? 'true' : 'false'" index="1"  @click="handleOpen(1)">
            <i class="el-icon-trophy" ></i>
            <span slot="title">公司简介
              <i class="el-icon-arrow-right" ></i></span>
          </el-menu-item>
          <el-menu-item :class="index == 2 ? 'true' : 'false'" index="2" @click="handleOpen(2)">
            <i class="el-icon-office-building" ></i>
            <span slot="title">发展历程
            <i class="el-icon-arrow-right"></i></span>
          </el-menu-item>
          <el-menu-item :class="index == 3 ? 'true' : 'false'" index="3"  @click="handleOpen(3)">
            <i class="el-icon-user"></i>
            <span slot="title">专业服务
            <i class="el-icon-arrow-right"></i></span>
          </el-menu-item>
          <el-menu-item :class="index == 4 ? 'true' : 'false'" index="4" @click="handleOpen(4)">
            <i class="el-icon-chat-dot-round"></i>
            <span slot="title">联系我们
            <i class="el-icon-arrow-right"></i></span>
          </el-menu-item>
        </el-menu>
      </el-col>
      <el-col :span="16">
        <div>
          <img  :class="index == 1 ? 'show' : 'dis'" src="../../static/images/about/one.png"  />
        </div>
        <div>
          <img  :class="index == 2 ? 'show' : 'dis'" src="../../static/images/about/two.png"  />
        </div>
        <div>
          <img  :class="index == 3 ? 'show' : 'dis'" src="../../static/images/about/three.png"  />
        </div>
        <div>
          <img  :class="index == 4 ? 'show' : 'dis'" src="../../static/images/about/four.png"  />
          <img  :class=" index == 4 ? 'show address' : 'dis address'" src="../../static/images/about/addres.png"  />
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
    export default {
        name: "about",
      data() {
          return {
              tabPosition: 'left',
              index: 1,
          };
      },
      methods: {
          handleOpen(index) {
              this.index = index;
          }
      }
    }
</script>

<style scoped>
  i{
    color: black;
  }
  .about-top{
    max-height: 32.5rem;
    padding-top: 15%;
    background: url("../../static/images/about/about-top.png") no-repeat center / cover;
  }
  /*下面的星号让素有元素内外边距都为0，不留空隙 */
  *{
    padding:0px;
    margin:0px;
    /*我们让整个屏幕都有一种淡淡的背景色*/
  }

  #main{
    width:100%;
    background-color:lightgoldenrodyellow;
  }

  .el-menu-vertical-demo{
    float: right;
  }

  /deep/ .el-menu-item{
    font-size: 1.125rem;
    padding: 0 10px!important;
  }

  .true i{
    color: inherit!important;
  }
  .true{
    color: #FFFFFF!important;
    background-color: #f2613f!important;
  }
  .false{
    color: rgb(0, 0, 0)!important;
    background-color: rgb(248, 248, 248)!important;
  }

  .show{
    display: inline-block;
  }
  .dis{
    display: none;
  }

  .address{
    width: 100%;
    margin: 40px auto;
    padding: 0 15px;
  }

  .el-icon-arrow-right{
    margin-left: 11%;
    margin-bottom: 1%;
  }
  #photoOne{
    float: left;
    height: 100%;
    width: 100%;
    padding-top: 31.5%;
    background: url("../../static/images/about/one.png") no-repeat center / cover;
    margin: 4rem 0;
  }
  #photoTwo{
    float: left;
    width: 100%;
    max-height: 37.63rem;
    padding-top: 31.5%;
    background: url("../../static/images/dutyInsurance/introduced/productInformation.png") no-repeat center / cover;
    margin: 4rem 0;
  }
  #photoThree{
    float: left;
    width: 80%;
    max-height: 37.63rem;
    padding-top: 31.5%;
    background: url("../../static/images/dutyInsurance/introduced/productInformation.png") no-repeat center / cover;
    margin: 4rem 0;
  }
  #photoFour{
    float: left;
    width: 80%;
    max-height: 37.63rem;
    padding-top: 31.5%;
    background: url("../../static/images/dutyInsurance/introduced/productInformation.png") no-repeat center / cover;
    margin: 4rem 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/about.vue